/**
 * Trellis Bliss - ONE CART REWARDS SYSTEM
 * Centralized cart manager with 'Rs.' formatting and compact reference buttons.
 */

(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var num = parseFloat(cents) / 100;
    if (isNaN(num)) return 'Rs. 0.00';
    var formatted = num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return 'Rs. ' + formatted;
  }

  function getAccessoryHandles() {
    var pageRoot = document.getElementById('CustomCartPage');
    var drawerRoot = document.getElementById('CustomCartDrawer');
    var raw = '';
    if (pageRoot) raw = pageRoot.getAttribute('data-accessories-handles') || '';
    if (!raw && drawerRoot) raw = drawerRoot.getAttribute('data-accessories-handles') || '';
    return raw.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  }

  window.openCustomCartDrawer = function () {
    var drawer = document.getElementById('CustomCartDrawer');
    if (drawer) {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      refreshAll();
    }
  };

  window.closeCustomCartDrawer = function () {
    var drawer = document.getElementById('CustomCartDrawer');
    if (drawer) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  };

  function updateCartLine(line, quantity) {
    setLoading(true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        renderAll(cart);
      })
      .catch(function (err) {
        console.error('Error updating cart:', err);
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function addProductToCart(variantId, isAccessory, callback) {
    setLoading(true);

    var postData = { id: variantId, quantity: 1 };
    if (isAccessory) {
      postData.properties = { '_milestone_reward': '50% OFF' };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(postData)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (item) {
        if (typeof callback === 'function') callback(null, item);
        refreshAll(function () {
          if (!window.location.pathname.includes('/cart')) {
            window.openCustomCartDrawer();
          }
        });
      })
      .catch(function (err) {
        console.error('Error adding to cart:', err);
        if (typeof callback === 'function') callback(err);
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function refreshAll(onComplete) {
    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        renderAll(cart);
        if (typeof onComplete === 'function') onComplete(cart);
      })
      .catch(function (err) {
        console.error('Error fetching cart:', err);
      });
  }

  function setLoading(isLoading) {
    var pageRoot = document.getElementById('CustomCartPage');
    var drawerRoot = document.getElementById('CustomCartDrawer');
    if (pageRoot) {
      if (isLoading) pageRoot.classList.add('loading');
      else pageRoot.classList.remove('loading');
    }
    if (drawerRoot) {
      if (isLoading) drawerRoot.classList.add('loading');
      else drawerRoot.classList.remove('loading');
    }
  }

  // Free mystery box: GoKwik adds the real gift at checkout, so the cart only shows a matching line.
  // Settings live on #CustomCartDrawer (snippets/cart-drawer.liquid): handle, min and max qualifying items, deal end.
  var giftShown = false, giftJustAdded = false;
  var GIFT_ICON = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';

  function giftConfig() {
    var d = document.getElementById('CustomCartDrawer');
    if (!d || !d.getAttribute('data-gift-handle')) return null;
    return {
      handle: d.getAttribute('data-gift-handle'),
      min: parseInt(d.getAttribute('data-gift-min') || '2', 10),
      max: parseInt(d.getAttribute('data-gift-max') || '2', 10),
      end: parseInt(d.getAttribute('data-deal-end') || '0', 10),
      img: d.getAttribute('data-gift-img') || ''
    };
  }

  function isGiftItem(item) {
    var g = giftConfig();
    return Boolean(item && item.handle === (g ? g.handle : 'free-mystery-box'));
  }

  // The box goes with 2 items only; at 3 items free delivery takes its place (offers do not stack).
  function giftWanted(qualifyingCount) {
    var g = giftConfig();
    if (!g) return false;
    if (g.end && Date.now() / 1000 > g.end) return false;
    return qualifyingCount >= g.min && qualifyingCount <= g.max;
  }

  // A box added to the cart by hand would come on top of GoKwik's own, so take it out.
  // Returns true when it started a cart change.
  function syncGift(cart, qualifyingCount) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftItem(cart.items[i])) { updateCartLine(i + 1, 0); return true; }
    }
    var wanted = giftWanted(qualifyingCount);
    giftJustAdded = wanted && !giftShown;
    giftShown = wanted;
    return false;
  }

  function giftLineHtml(isPage) {
    var g = giftConfig();
    var img = (g && g.img) || '';
    var cls = (isPage ? 'custom-cart-item-card' : 'custom-cart-item') + ' tb-gift-line' + (giftJustAdded ? ' tb-gift-new' : '');
    return '<div class="' + cls + '">' +
      '<div class="' + (isPage ? 'custom-cart-item-thumb' : 'custom-cart-item-img') + ' tb-gift-img">' +
        (img ? '<img src="' + img + '" alt="Free mystery box">' : '') +
      '</div>' +
      '<div class="tb-gift-info">' +
        '<div class="tb-gift-title">Free Mystery Box</div>' +
        '<div class="tb-gift-badge">' + GIFT_ICON + 'Free with your 2 items</div>' +
        '<div class="tb-gift-note">Worth ₹299. Added free at checkout.</div>' +
      '</div>' +
      '<div class="tb-gift-price">FREE</div>' +
    '</div>';
  }

  // Item counts leave the free box out, so 2 items reads as 2.
  function shownCount(cart) {
    var n = cart.item_count || 0;
    (cart.items || []).forEach(function (item) { if (isGiftItem(item)) n -= item.quantity; });
    return n;
  }

  function rewardTitle(qualifyingCount) {
    var g = giftConfig();
    var giftAt3 = g && g.max >= 3;
    if (qualifyingCount === 0) return '<span class="sparkle-icon">✦</span> Add 1 item to unlock 50% off handmade planters!';
    if (qualifyingCount === 1) return '<span class="sparkle-icon">✦</span> Add 1 more item to get a free mystery box!';
    if (qualifyingCount === 2) return '<span class="sparkle-icon">🎁</span> Free mystery box unlocked! ' + (giftAt3 ? 'Add 1 more item for free delivery.' : 'Or add 1 more item to swap it for free delivery.');
    return '<span class="sparkle-icon">🎉</span> ' + (giftAt3 ? 'Mystery box and free delivery unlocked!' : 'Free delivery unlocked on your whole order!');
  }

  function giftMilestoneOn(qualifyingCount) {
    var g = giftConfig();
    return qualifyingCount >= 2 && (!g || qualifyingCount <= g.max);
  }

  function getQualifyingCount(cart) {
    if (!cart || !cart.items) return 0;
    var count = 0;
    cart.items.forEach(function (item) {
      var isReward = Boolean(item.properties && (item.properties['_milestone_reward'] === '50% OFF' || item.properties['_reward_type'] === 'accessory_50'));
      if (!isReward && !isGiftItem(item)) {
        count += item.quantity;
      }
    });
    return count;
  }

  function renderAll(cart) {
    window.cart = cart;
    var itemCount = shownCount(cart);
    var qualifyingCount = getQualifyingCount(cart);
    var accHandles = getAccessoryHandles();
    var isMilestone1Unlocked = qualifyingCount >= 1;

    // If qualifying count dropped below 1, remove any reward accessories added with 50% off
    if (qualifyingCount < 1) {
      for (var r = 0; r < cart.items.length; r++) {
        var rItem = cart.items[r];
        if (rItem.properties && (rItem.properties['_milestone_reward'] === '50% OFF' || rItem.properties['_reward_type'] === 'accessory_50')) {
          updateCartLine(r + 1, 0);
          return;
        }
      }
    }

    syncGift(cart, qualifyingCount);

    // Update global cart counts
    document.querySelectorAll('[data-cart-count], .cart-count-bubble, .header__cart-count').forEach(function (el) {
      el.textContent = itemCount;
    });

    // 1. Render Drawer
    renderCartDrawer(cart, accHandles, isMilestone1Unlocked, qualifyingCount);

    // 2. Render Cart Page (if present)
    renderCartPage(cart, accHandles, isMilestone1Unlocked, qualifyingCount);
    giftJustAdded = false;
  }

  function renderCartDrawer(cart, accHandles, isMilestone1Unlocked, qualifyingCount) {
    var drawer = document.getElementById('CustomCartDrawer');
    if (!drawer) return;

    var itemCount = shownCount(cart);
    var countEls = drawer.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) { el.textContent = itemCount; });

    var itemsContainer = drawer.querySelector('[data-cart-items]');
    var rewardBox = document.getElementById('drawerRewardBox');

    if (itemCount === 0) {
      if (itemsContainer) itemsContainer.innerHTML = '<div class="custom-cart-empty">Your cart is currently empty.</div>';
      if (rewardBox) rewardBox.style.display = 'none';
      var savingsEl = document.getElementById('drawerSavingsBanner');
      if (savingsEl) savingsEl.classList.add('hidden');
      var totalEls = drawer.querySelectorAll('[data-cart-total]');
      totalEls.forEach(function (el) { el.textContent = formatMoney(0); });
      var drawerAcc = document.getElementById('drawerAccessoriesSection');
      if (drawerAcc) drawerAcc.style.display = 'none';
      return;
    }

    if (rewardBox) rewardBox.style.display = 'block';

    // Drawer Progression Bar
    updateDrawerRewardBar(qualifyingCount);

    // Show Garden Accessories Section with enabled/disabled state based on qualifying milestone
    var drawerAccSec = document.getElementById('drawerAccessoriesSection');
    if (drawerAccSec) {
      drawerAccSec.style.display = 'block';
      var badge = document.getElementById('drawerAccLockBadge');
      var accButtons = drawerAccSec.querySelectorAll('button[data-is-accessory="true"]');
      var accPriceEls = drawerAccSec.querySelectorAll('.drawer-card-prices');

      if (isMilestone1Unlocked) {
        drawerAccSec.classList.remove('is-locked');
        accButtons.forEach(function(b) { b.removeAttribute('disabled'); });
        if (badge) {
          badge.className = 'drawer-offer-badge unlocked';
          badge.textContent = 'Unlocked';
        }
      } else {
        drawerAccSec.classList.add('is-locked');
        accButtons.forEach(function(b) { b.setAttribute('disabled', 'disabled'); });
        if (badge) {
          badge.className = 'drawer-offer-badge locked';
          badge.textContent = '🔒 Add 1 item';
        }
      }

      // Display 50% offer price with strikethrough original price
      accPriceEls.forEach(function(el) {
        var rawPrice = parseInt(el.getAttribute('data-orig-price') || 0, 10);
        if (rawPrice > 0) {
          var discPrice = Math.round(rawPrice * 0.5);
          el.innerHTML = '<span class="drawer-card-regular-price drawer-card-offer-price" style="color: #245436; font-weight: 700;">' + formatMoney(discPrice) + '</span>' +
                         '<s class="drawer-card-orig-price drawer-card-strikethrough">' + formatMoney(rawPrice) + '</s>';
        }
      });
    }

    // Drawer Items
    var totalAccDiscount = 0;
    var finalDrawerTotal = 0;
    if (itemsContainer) {
      var html = '';
      var giftHtml = giftWanted(qualifyingCount) ? giftLineHtml(false) : '';
      cart.items.forEach(function (item, idx) {
        var lineNum = idx + 1;
        if (isGiftItem(item)) return;
        var imgSrc = item.image ? item.image : '';
        var isAcc = Boolean(item.properties && (item.properties['_milestone_reward'] === '50% OFF' || item.properties['_reward_type'] === 'accessory_50'));

        var finalPrice = item.final_line_price;
        if (isMilestone1Unlocked && isAcc) {
          var disc = Math.round(item.original_line_price * 0.5);
          totalAccDiscount += disc;
          finalPrice = item.original_line_price - disc;
        }

        finalDrawerTotal += finalPrice;

        var offerBadge = isAcc ? '<div class="custom-cart-offer-badge">🎁 50% OFF Offer</div>' : '';
        var variantTitle = item.variant_title ? '<div class="custom-cart-item-variant">Size: ' + item.variant_title + '</div>' : '';

        html += '<div class="custom-cart-item" data-line="' + lineNum + '">' +
          '<div class="custom-cart-item-img">' +
            '<img src="' + imgSrc + '" alt="' + item.product_title + '">' +
          '</div>' +
          '<div class="custom-cart-item-info">' +
            '<div class="custom-cart-item-title">' + item.product_title + '</div>' +
            offerBadge +
            variantTitle +
            '<div class="custom-cart-item-qty-bar">' +
              '<button type="button" class="custom-cart-qty-btn" data-cart-qty-change="-1" data-line="' + lineNum + '" data-qty="' + item.quantity + '">−</button>' +
              '<span class="custom-cart-qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="custom-cart-qty-btn" data-cart-qty-change="1" data-line="' + lineNum + '" data-qty="' + item.quantity + '">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="custom-cart-item-actions">' +
            '<button type="button" class="custom-cart-item-remove" data-cart-remove data-line="' + lineNum + '" aria-label="Remove item">&times;</button>' +
            '<div class="custom-cart-item-price">' + formatMoney(finalPrice) + '</div>' +
          '</div>' +
        '</div>';
      });
      itemsContainer.innerHTML = html + giftHtml;
    }

    // Update Drawer Total
    var totalEls = drawer.querySelectorAll('[data-cart-total]');
    totalEls.forEach(function (el) { el.textContent = formatMoney(finalDrawerTotal); });

    // Drawer Savings Banner
    var savingsBanner = document.getElementById('drawerSavingsBanner');
    var savingsAmount = document.getElementById('drawerSavingsAmount');
    updateSavingsBanner(savingsBanner, savingsAmount, cart, totalAccDiscount);
  }

  function updateDrawerRewardBar(qualifyingCount) {
    var titleEl = document.getElementById('drawerRewardTitle');
    var fillEl = document.getElementById('drawerProgressFill');
    var m1 = document.getElementById('drawerM1');
    var m2 = document.getElementById('drawerM2');
    var m3 = document.getElementById('drawerM3');

    if (!titleEl || !fillEl || !m1 || !m2 || !m3) return;

    if (qualifyingCount === 0) {
      titleEl.innerHTML = '<span class="sparkle-icon">✦</span> Add 1 item to unlock 50% off handmade planters!';
      fillEl.style.width = '0%';
      m1.className = 'drawer-milestone';
      m2.className = 'drawer-milestone';
      m3.className = 'drawer-milestone';
    } else if (qualifyingCount === 1) {
      titleEl.innerHTML = '<span class="sparkle-icon">✦</span> Add 1 more item to unlock Free Mystery Box!';
      fillEl.style.width = '0%';
      m1.className = 'drawer-milestone unlocked';
      m2.className = 'drawer-milestone active';
      m3.className = 'drawer-milestone';
    } else if (qualifyingCount === 2) {
      fillEl.style.width = '50%';
      m1.className = 'drawer-milestone unlocked';
      m2.className = 'drawer-milestone unlocked';
      m3.className = 'drawer-milestone active';
    } else {
      fillEl.style.width = '100%';
      m1.className = 'drawer-milestone unlocked';
      m2.className = 'drawer-milestone' + (giftMilestoneOn(qualifyingCount) ? ' unlocked' : '');
      m3.className = 'drawer-milestone unlocked';
    }
    titleEl.innerHTML = rewardTitle(qualifyingCount);
  }

  function renderCartPage(cart, accHandles, isMilestone1Unlocked, qualifyingCount) {
    var pageRoot = document.getElementById('CustomCartPage');
    if (!pageRoot) return;

    var itemCount = shownCount(cart);
    var container = document.getElementById('CustomCartContainer');
    var emptyContainer = document.getElementById('CustomCartEmptyState');
    var stickyBar = document.getElementById('CustomCartStickyCheckout');
    var headerCount = document.getElementById('customCartHeaderCount');

    if (itemCount === 0) {
      if (container) container.style.display = 'none';
      if (emptyContainer) emptyContainer.style.display = 'block';
      if (stickyBar) stickyBar.style.display = 'none';
      if (headerCount) headerCount.textContent = '(0 items)';
      return;
    }

    if (container) container.style.display = 'block';
    if (emptyContainer) emptyContainer.style.display = 'none';
    if (stickyBar) stickyBar.style.display = 'block';
    if (headerCount) headerCount.textContent = '(' + itemCount + ' ' + (itemCount === 1 ? 'item' : 'items') + ')';

    // Page Promos
    updatePagePromos(qualifyingCount);

    // Page Reward Bar
    updatePageRewardBar(qualifyingCount);

    // Show Garden Accessories Section on Cart Page with enabled/disabled state based on qualifying milestone
    var pageAccSec = document.getElementById('customCartAccessoriesSection');
    if (pageAccSec) {
      pageAccSec.style.display = 'block';
      var pageBadge = document.getElementById('pageAccLockBadge');
      var pageAccButtons = pageAccSec.querySelectorAll('button[data-is-accessory="true"]');
      var pageAccPriceEls = pageAccSec.querySelectorAll('.drawer-card-prices');

      if (isMilestone1Unlocked) {
        pageAccSec.classList.remove('is-locked');
        pageAccButtons.forEach(function (b) { b.removeAttribute('disabled'); });
        if (pageBadge) {
          pageBadge.className = 'drawer-offer-badge unlocked';
          pageBadge.textContent = 'Unlocked';
        }
      } else {
        pageAccSec.classList.add('is-locked');
        pageAccButtons.forEach(function (b) { b.setAttribute('disabled', 'disabled'); });
        if (pageBadge) {
          pageBadge.className = 'drawer-offer-badge locked';
          pageBadge.textContent = '🔒 Add 1 item to unlock';
        }
      }

      // Display 50% offer price with strikethrough original price
      pageAccPriceEls.forEach(function(el) {
        var rawPrice = parseInt(el.getAttribute('data-orig-price') || 0, 10);
        if (rawPrice > 0) {
          var discPrice = Math.round(rawPrice * 0.5);
          el.innerHTML = '<span class="drawer-card-regular-price drawer-card-offer-price" style="color: #245436; font-weight: 700;">' + formatMoney(discPrice) + '</span>' +
                         '<s class="drawer-card-orig-price drawer-card-strikethrough">' + formatMoney(rawPrice) + '</s>';
        }
      });
    }

    // Page Items
    var itemsListEl = document.getElementById('customCartItemsList');
    var pageResult = renderPageItems(itemsListEl, cart, accHandles, isMilestone1Unlocked);

    // Page Savings
    var savingsBanner = document.getElementById('customCartSavingsBanner');
    var savingsAmount = document.getElementById('customCartSavingsAmount');
    updateSavingsBanner(savingsBanner, savingsAmount, cart, pageResult.totalAccDiscount);

    // Page Checkout
    var totalCountEl = document.getElementById('customCartTotalCount');
    var totalAmountEl = document.getElementById('customCartTotalAmount');
    var discountInputEl = document.getElementById('customCartDiscountInput');
    updateCheckoutTotals(totalCountEl, totalAmountEl, discountInputEl, cart, pageResult.finalTotal);
  }

  function updatePagePromos(qualifyingCount) {
    var r1 = document.getElementById('promoRow1');
    var r2 = document.getElementById('promoRow2');
    var r3 = document.getElementById('promoRow3');
    if (!r1 || !r2 || !r3) return;

    var n1 = Math.max(0, 1 - qualifyingCount);
    r1.querySelector('.custom-cart-promo-text').textContent = qualifyingCount >= 1 ? '50% off handmade planters unlocked!' : 'Add 1 item to get 50% off handmade planters.';

    var n2 = Math.max(0, 2 - qualifyingCount);
    r2.querySelector('.custom-cart-promo-text').textContent = giftMilestoneOn(qualifyingCount) ? 'Free mystery box unlocked, added at checkout!' : qualifyingCount >= 2 ? 'Free delivery replaces the mystery box at 3 items.' : 'Add ' + n2 + ' more item' + (n2 > 1 ? 's' : '') + ' to get a free mystery box.';

    var n3 = Math.max(0, 3 - qualifyingCount);
    r3.querySelector('.custom-cart-promo-text').textContent = qualifyingCount >= 3 ? 'Free delivery unlocked!' : 'Add ' + n3 + ' more item' + (n3 > 1 ? 's' : '') + ' to unlock free delivery on your whole order.';
  }

  function updatePageRewardBar(qualifyingCount) {
    var titleEl = document.getElementById('customCartRewardTitle');
    var fillEl = document.getElementById('customCartProgressFill');
    var m1 = document.getElementById('milestone1');
    var m2 = document.getElementById('milestone2');
    var m3 = document.getElementById('milestone3');

    if (!titleEl || !fillEl || !m1 || !m2 || !m3) return;

    if (qualifyingCount === 0) {
      titleEl.innerHTML = '<span class="sparkle-icon">✦</span> Add 1 item to unlock 50% off handmade planters!';
      fillEl.style.width = '0%';
      m1.className = 'custom-cart-milestone';
      m2.className = 'custom-cart-milestone';
      m3.className = 'custom-cart-milestone';
    } else if (qualifyingCount === 1) {
      titleEl.innerHTML = '<span class="sparkle-icon">✦</span> Add 1 more item to unlock Free Mystery Box!';
      fillEl.style.width = '0%';
      m1.className = 'custom-cart-milestone unlocked';
      m2.className = 'custom-cart-milestone active';
      m3.className = 'custom-cart-milestone';
    } else if (qualifyingCount === 2) {
      fillEl.style.width = '50%';
      m1.className = 'custom-cart-milestone unlocked';
      m2.className = 'custom-cart-milestone unlocked';
      m3.className = 'custom-cart-milestone active';
    } else {
      fillEl.style.width = '100%';
      m1.className = 'custom-cart-milestone unlocked';
      m2.className = 'custom-cart-milestone' + (giftMilestoneOn(qualifyingCount) ? ' unlocked' : '');
      m3.className = 'custom-cart-milestone unlocked';
    }
    titleEl.innerHTML = rewardTitle(qualifyingCount);
  }

  function renderPageItems(container, cart, accHandles, isMilestone1Unlocked) {
    if (!container) return { totalAccDiscount: 0, finalTotal: cart.total_price };

    var totalAccDiscount = 0;
    var finalTotal = 0;
    var html = '';
    var giftHtml = giftWanted(getQualifyingCount(cart)) ? giftLineHtml(true) : '';

    cart.items.forEach(function (item, idx) {
      var lineNum = idx + 1;
      if (isGiftItem(item)) return;
      var imgSrc = item.image ? item.image : '';
      var isAcc = Boolean(item.properties && (item.properties['_milestone_reward'] === '50% OFF' || item.properties['_reward_type'] === 'accessory_50'));

      var finalLinePrice = item.final_line_price;
      var comparePrice = '';

      if (isMilestone1Unlocked && isAcc) {
        var disc = Math.round(item.original_line_price * 0.5);
        totalAccDiscount += disc;
        finalLinePrice = item.original_line_price - disc;
        comparePrice = formatMoney(item.original_line_price);
      } else if (item.variant_compare_at_price && item.variant_compare_at_price > item.price) {
        comparePrice = formatMoney(item.variant_compare_at_price * item.quantity);
      }

      finalTotal += finalLinePrice;

      var offerBadge = isAcc ? '<div class="custom-cart-offer-badge">🎁 50% OFF Offer</div>' : '';
      var itemPriceFormatted = formatMoney(finalLinePrice);
      var variantTitle = item.variant_title ? '<div class="custom-cart-item-variant">' + item.variant_title + '</div>' : '';

      html += '<div class="custom-cart-item-card" data-line="' + lineNum + '" data-handle="' + item.handle + '">' +
        '<div class="custom-cart-item-left">' +
          '<div class="custom-cart-item-thumb">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="custom-cart-item-details">' +
            '<a href="' + item.url + '" class="custom-cart-item-name">' + item.product_title + '</a>' +
            offerBadge +
            variantTitle +
            '<div class="custom-cart-item-prices">' +
              '<span class="custom-cart-item-price">' + itemPriceFormatted + '</span>' +
              (comparePrice ? '<span class="custom-cart-item-compare-price">' + comparePrice + '</span>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="custom-cart-item-right">' +
          '<div class="custom-cart-qty-control">' +
            '<button type="button" class="custom-cart-qty-btn" data-cart-qty-change="-1" data-line="' + lineNum + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
            '<span class="custom-cart-qty-number">' + item.quantity + '</span>' +
            '<button type="button" class="custom-cart-qty-btn" data-cart-qty-change="1" data-line="' + lineNum + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="custom-cart-item-remove-btn" data-cart-remove data-line="' + lineNum + '" aria-label="Remove ' + item.product_title + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>' +
          '</button>' +
        '</div>' +
      '</div>';
    });

    container.innerHTML = html + giftHtml;
    return { totalAccDiscount: totalAccDiscount, finalTotal: finalTotal };
  }

  function updateSavingsBanner(bannerEl, amountEl, cart, accessoryDiscount) {
    if (!bannerEl || !amountEl) return;

    var totalSavings = 0;
    cart.items.forEach(function (item) {
      if (isGiftItem(item)) return;
      var isAcc = Boolean(item.properties && (item.properties['_milestone_reward'] === '50% OFF' || item.properties['_reward_type'] === 'accessory_50'));
      if (isAcc) {
        var accDisc = Math.round(item.original_line_price * 0.5);
        totalSavings += accDisc;
        if (item.variant_compare_at_price && item.variant_compare_at_price > item.original_price) {
          totalSavings += (item.variant_compare_at_price - item.original_price) * item.quantity;
        }
      } else {
        if (item.variant_compare_at_price && item.variant_compare_at_price > item.price) {
          totalSavings += (item.variant_compare_at_price - item.price) * item.quantity;
        }
        if (item.line_level_total_discount) {
          totalSavings += item.line_level_total_discount;
        }
      }
    });

    if (totalSavings > 0) {
      bannerEl.classList.remove('hidden');
      amountEl.textContent = formatMoney(totalSavings);
    } else {
      bannerEl.classList.add('hidden');
    }
  }

  function updateCheckoutTotals(countEl, amountEl, discountInput, cart, pageTotal) {
    var itemCount = shownCount(cart);
    if (countEl) {
      countEl.textContent = '(' + itemCount + ' ' + (itemCount === 1 ? 'item' : 'items') + ')';
    }

    if (amountEl) {
      amountEl.textContent = formatMoney(pageTotal);
    }

    if (discountInput) {
      var hasAccessoryDiscount = cart.items.some(function(item) {
        return Boolean(item.properties && (item.properties['_milestone_reward'] === '50% OFF' || item.properties['_reward_type'] === 'accessory_50'));
      });
      if (SEND_MILESTONE_CODES && itemCount >= 1 && hasAccessoryDiscount) {
        discountInput.removeAttribute('disabled');
      } else {
        discountInput.setAttribute('disabled', 'disabled');
      }
    }
  }

  function initCarousels() {
    document.querySelectorAll('.drawer-nav-arrow, .custom-cart-nav-arrow').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var direction = this.getAttribute('data-direction');
        var targetId = this.getAttribute('data-target');
        var track = document.getElementById(targetId);
        if (track) {
          var isPage = btn.classList.contains('custom-cart-nav-arrow');
          var cardWidth = isPage ? 260 : 180;
          var scrollAmount = cardWidth * (direction === 'next' ? 1 : -1);
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    });
  }

  function initEvents() {
    // Drawer open / close
    document.addEventListener('click', function (e) {
      if (e.target.closest('.custom-btn-view-cart')) {
        return; // Allow direct navigation to /cart page
      }

      var openBtn = e.target.closest('[data-cart-drawer-open], .header__icon--cart, a[href="/cart"]:not(.custom-btn-view-cart)');
      if (openBtn && !window.location.pathname.includes('/cart')) {
        e.preventDefault();
        window.openCustomCartDrawer();
        return;
      }

      var closeBtn = e.target.closest('[data-cart-drawer-close]');
      if (closeBtn) {
        e.preventDefault();
        window.closeCustomCartDrawer();
        return;
      }

      // Quantity adjustments
      var qtyBtn = e.target.closest('[data-cart-qty-change], [data-custom-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        var delta = parseInt(qtyBtn.getAttribute('data-cart-qty-change') || qtyBtn.getAttribute('data-custom-cart-qty'), 10);
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var currentQty = parseInt(qtyBtn.getAttribute('data-qty') || qtyBtn.getAttribute('data-current-qty'), 10);
        var newQty = Math.max(0, currentQty + delta);
        updateCartLine(line, newQty);
        return;
      }

      // Line item removal
      var removeBtn = e.target.closest('[data-cart-remove], [data-custom-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        var lineR = parseInt(removeBtn.getAttribute('data-line'), 10);
        updateCartLine(lineR, 0);
        return;
      }

      // Add to Cart from Carousels
      var addBtn = e.target.closest('[data-custom-cart-add]');
      if (addBtn) {
        e.preventDefault();
        if (addBtn.hasAttribute('disabled') || addBtn.disabled || addBtn.closest('.is-locked')) {
          return;
        }
        var variantId = addBtn.getAttribute('data-variant-id');
        var isAcc = addBtn.getAttribute('data-is-accessory') === 'true';
        if (variantId) {
          addProductToCart(variantId, isAcc);
        }
        return;
      }

      // Checkout button click
      var checkoutBtn = e.target.closest('.custom-cart-checkout-btn, .custom-btn-checkout');
      if (checkoutBtn) {
        e.preventDefault();
        window.handleCustomCheckout(checkoutBtn);
        return;
      }
    });
  }

  function getMilestoneCodes() {
    var pageRoot = document.getElementById('CustomCartPage');
    var drawerRoot = document.getElementById('CustomCartDrawer');
    var m1 = '', m2 = '', m3 = '';
    if (drawerRoot) {
      m1 = drawerRoot.getAttribute('data-milestone1-code') || '';
      m2 = drawerRoot.getAttribute('data-milestone2-code') || '';
      m3 = drawerRoot.getAttribute('data-milestone3-code') || '';
    }
    if (!m1 && pageRoot) {
      m1 = pageRoot.getAttribute('data-milestone1-code') || pageRoot.getAttribute('data-discount-code') || '';
      m2 = pageRoot.getAttribute('data-milestone2-code') || '';
      m3 = pageRoot.getAttribute('data-milestone3-code') || '';
    }
    return {
      m1: (m1 || 'GARDEN50').trim(),
      m2: (m2 || 'FREEBIE').trim(),
      m3: (m3 || 'FREESHIP').trim()
    };
  }

  // The Diwali offers are automatic discounts in Shopify, so no code is sent. The milestone codes
  // (GARDEN50, FREEBIE, FREESHIP) never existed and made GoKwik show "discount code entered is invalid".
  // Shoppers still enter their own codes in GoKwik's coupon box. The hidden cart page field stays off too.
  var SEND_MILESTONE_CODES = false;

  function getActiveMilestoneDiscount(cart) {
    if (!SEND_MILESTONE_CODES) return '';
    var qualifyingCount = getQualifyingCount(cart);
    var codes = getMilestoneCodes();
    if (qualifyingCount >= 3 && codes.m3) {
      return codes.m3;
    }
    if (qualifyingCount >= 2 && codes.m2) {
      return codes.m2;
    }
    if (qualifyingCount >= 1 && codes.m1) {
      return codes.m1;
    }
    return '';
  }

  // Shopify keeps every code a cart was ever sent. Old ones that do not apply (GARDEN50, FREEBIE,
  // FREESHIP from before, or any expired code) make GoKwik open with "discount code entered is invalid",
  // so drop them and keep only codes that still apply. Runs on page load and before checkout.
  function clearDeadDiscounts(done) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var live = codes.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        var cookie = (document.cookie.match(/(?:^|; )discount_code=([^;]*)/) || [])[1];
        if (cookie && live.indexOf(decodeURIComponent(cookie)) === -1) {
          document.cookie = 'discount_code=; path=/; max-age=0';
        }
        if (live.length === codes.length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: live.join(',') })
        });
      })
      .catch(function (err) { console.warn('Could not clear old discount codes:', err); })
      .then(function () { if (typeof done === 'function') done(); });
  }

  window.handleCustomCheckout = function (btn) {
    clearDeadDiscounts(function () { startCheckout(btn); });
  };

  function startCheckout(btn) {
    if (btn) {
      btn.style.opacity = '0.85';
      var txtSpan = btn.querySelector('span');
      if (txtSpan) {
        txtSpan.textContent = 'CHECKOUT...';
      }
    }

    var discountInput = document.getElementById('customCartDiscountInput');
    var manualCode = (SEND_MILESTONE_CODES && discountInput && !discountInput.disabled && discountInput.value) ? discountInput.value.trim() : '';
    var milestoneCode = getActiveMilestoneDiscount(window.cart || {});
    var discountCode = manualCode || milestoneCode || '';

    if (discountCode) {
      try {
        sessionStorage.setItem('gokwik_discount', discountCode);
        if (window.gokwikSdk && typeof window.gokwikSdk.applyCoupon === 'function') {
          window.gokwikSdk.applyCoupon(discountCode);
        }
      } catch (e) {}

      try {
        fetch('/discount/' + encodeURIComponent(discountCode), { method: 'GET', credentials: 'same-origin' });
      } catch (e) {}
    }

    // 1. Look for GoKwik checkout button rendered on the page/drawer
    var gkBtn = document.querySelector('.gokwik-checkout button');
    if (gkBtn) {
      gkBtn.disabled = false;
      gkBtn.classList.remove('disabled');

      if (typeof onCheckoutClick === 'function') {
        try {
          onCheckoutClick(gkBtn);
          setTimeout(function () {
            if (btn) {
              btn.style.opacity = '1';
              btn.style.pointerEvents = 'auto';
              var s = btn.querySelector('span');
              if (s) s.textContent = btn.classList.contains('custom-btn-checkout') ? 'PROCEED TO CHECKOUT' : 'CHECKOUT';
            }
          }, 3000);
          return;
        } catch (e) {
          console.warn('onCheckoutClick(gkBtn) error:', e);
        }
      }

      try {
        gkBtn.click();
        setTimeout(function () {
          if (btn) {
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
            var s = btn.querySelector('span');
            if (s) s.textContent = btn.classList.contains('custom-btn-checkout') ? 'PROCEED TO CHECKOUT' : 'CHECKOUT';
          }
        }, 3000);
        return;
      } catch (e) {
        console.warn('gkBtn.click() error:', e);
      }
    }

    // 2. Direct onCheckoutClick if available
    if (typeof onCheckoutClick === 'function') {
      try {
        onCheckoutClick(btn);
        setTimeout(function () {
          if (btn) {
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
            var s = btn.querySelector('span');
            if (s) s.textContent = btn.classList.contains('custom-btn-checkout') ? 'PROCEED TO CHECKOUT' : 'CHECKOUT';
          }
        }, 3000);
        return;
      } catch (e) {
        console.warn('Direct onCheckoutClick error:', e);
      }
    }

    // 3. Fallback to native Shopify checkout
    var targetUrl = '/checkout';
    if (discountCode) {
      targetUrl = '/checkout?discount=' + encodeURIComponent(discountCode);
    }
    window.location.href = targetUrl;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initEvents();
    initCarousels();
    clearDeadDiscounts();
    refreshAll();
  });

})();
